import { render, staticRenderFns } from "./executivePage.vue?vue&type=template&id=3940dd6a&scoped=true&"
import script from "./executivePage.vue?vue&type=script&lang=js&"
export * from "./executivePage.vue?vue&type=script&lang=js&"
import style0 from "./executivePage.vue?vue&type=style&index=0&id=3940dd6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3940dd6a",
  null
  
)

export default component.exports